import type { DataErrorRepository } from '../data/data-error-repository';

export class RebuildPaymentsUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(operatorId: number): Promise<{ isSuccess: boolean; errorMessage?: string }> {
    try {
      await this.repository.rebuildPayments(operatorId);
      return { isSuccess: true };
    } catch (error: unknown) {
      return {
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Failed to trigger payment rebuild',
      };
    }
  }
}
